import { Controller } from "@hotwired/stimulus"

// Exibe/oculta a senha e calcula sua força em cinco critérios.
export default class extends Controller {
  static targets = ["input", "icon", "meter", "segment", "label"]

  connect() {
    if (this.hasMeterTarget) this.evaluate()
  }

  toggle() {
    if (!this.hasInputTarget) return

    const visible = this.inputTarget.type === "text"
    this.inputTarget.type = visible ? "password" : "text"

    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("fa-eye", visible)
      this.iconTarget.classList.toggle("fa-eye-slash", !visible)
    }
  }

  evaluate() {
    if (!this.hasMeterTarget) return

    const value = this.inputTarget.value
    const { filled, text, color, textColor } = this.strength(value)

    this.meterTarget.classList.toggle("d-none", value.length === 0)
    this.segmentTargets.forEach((segment, index) => {
      segment.className = `flex-fill rounded-pill ${index < filled ? color : "bg-secondary bg-opacity-25"}`
      segment.style.height = "5px"
    })

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = text
      this.labelTarget.className = `small fw-medium mt-1 d-block ${textColor}`
    }
  }

  strength(password) {
    if (!password) return { filled: 0, text: "", color: "", textColor: "" }

    let points = 0
    if (password.length >= 8) points += 1
    if (/[a-z]/.test(password)) points += 1
    if (/[A-Z]/.test(password)) points += 1
    if (/\d/.test(password)) points += 1
    if (/[^A-Za-z0-9]/.test(password)) points += 1

    if (points <= 2) {
      return { filled: Math.max(points, 1), text: "Fraca", color: "bg-danger", textColor: "text-danger" }
    }

    if (points <= 4) {
      return { filled: points, text: "Média", color: "bg-warning", textColor: "text-warning" }
    }

    return { filled: 5, text: "Forte", color: "bg-success", textColor: "text-success" }
  }
}
